import { useInView } from '../hooks/useInView';
import { heroContent } from '../data/mock';
import { Button } from './ui/button';
import { ArrowRight, MessageCircle } from 'lucide-react';

export const CTASection = ({ onBookDemo }) => {
  const [ref, isInView] = useInView();

  return (
    <section className="relative py-28 bg-[#0A1628] overflow-hidden">
      {/* Decorative orbs */}
      <div className="absolute top-0 left-1/4 w-[400px] h-[400px] bg-[#D4A853]/5 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#D4A853]/5 rounded-full blur-[120px] pointer-events-none" />

      {/* Grid pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.015)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.015)_1px,transparent_1px)] bg-[size:64px_64px] pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" ref={ref}>
        <div
          className={`transition-[opacity,transform] duration-700 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            Ready to Start Your
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#E8C87A] to-[#D4A853]">
              Global Journey?
            </span>
          </h2>
          <p className="text-white/50 text-lg sm:text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
            Compare your options. Choose experience. Choose results. Book your free counseling session today and take the first step toward your dream.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a href="#contact">
              <Button
                className="bg-[#D4A853] hover:bg-[#C9A84C] text-[#0A1628] font-bold px-10 py-6 text-lg rounded-full shadow-lg shadow-[#D4A853]/25 hover:shadow-[#D4A853]/50 transition-[background-color,box-shadow] duration-300 group"
                style={{ animation: 'glowPulse 3s ease-in-out infinite' }}
                onClick={onBookDemo}
              >
                Talk to a Real Expert
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
              </Button>
            </a>
            <a href={`https://wa.me/${heroContent.whatsappNumber}`} target="_blank" rel="noopener noreferrer">
              <Button
                variant="outline"
                className="border-white/20 text-white hover:bg-white/10 px-10 py-6 text-lg rounded-full transition-[background-color,border-color] duration-300"
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                WhatsApp Now
              </Button>
            </a>
          </div>

          <p className="text-white/30 text-sm">No fees. No pressure. Just honest guidance.</p>
        </div>
      </div>
    </section>
  );
};
